import React, { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M15.9643 7.1964V4.79589C15.9643 2.09531 13.3007 -0.593257 10.26 0.114895C8.02071 0.631005 6.53571 2.81548 6.53571 5.14397V7.1964H5.35714C4.06071 7.1964 3 8.27663 3 9.59692V21.5995C3 22.9198 4.06071 24 5.35714 24H17.1429C18.4393 24 19.5 22.9198 19.5 21.5995V9.59692C19.5 8.27663 18.4393 7.1964 17.1429 7.1964H15.9643ZM8.89286 4.79589C8.89286 3.47561 9.95357 2.39538 11.25 2.39538C12.5464 2.39538 13.6071 3.59563 13.6071 4.79589V7.1964H8.89286V4.79589ZM17.1429 20.3992C17.1429 21.0594 16.6125 21.5995 15.9643 21.5995H6.53571C5.8875 21.5995 5.35714 21.0594 5.35714 20.3992V10.7972C5.35714 10.137 5.8875 9.59692 6.53571 9.59692H15.9643C16.6125 9.59692 17.1429 10.137 17.1429 10.7972V20.3992Z' />
        </SvgIcon>
    );
});
